module.exports = __webpack_public_path__ + "static/media/feature_2.f49bbe78.png";